import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';
import { IGlobalEnbId, IGlobalGnbId, TNodeCardTypeValue } from './interfaces';

import { ETechnologiesLabels, ETechnologiesValues } from '@enums/common';

export const limenetTechnologyTabs = [
	{
		title: ETechnologiesLabels.C_4G_TDD,
		value: ETechnologiesValues.C_4G_TDD,
		isVisible: true,
	},
	{
		title: ETechnologiesLabels.C_4G_FDD,
		value: ETechnologiesValues.C_4G_FDD,
		isVisible: true,
	},
	{
		title: ETechnologiesLabels.C_5G,
		value: ETechnologiesValues.C_5G,
		isVisible: true,
	},
];

export const limenetNodesTabs = [
	{
		title: ETechnologiesLabels.C_IMS,
		value: ETechnologiesValues.C_IMS,
		isVisible: true,
	},
	{
		title: ETechnologiesLabels.C_MME,
		value: ETechnologiesValues.C_MME,
		isVisible: true,
	},
];

export const EConfigType = {
	C_4G_TDD: 'cells4gTdd',
	C_4G_FDD: 'cells4gFdd',
	C_5G: 'cells5g',
} as const;

export type TConfigType = typeof EConfigType[keyof typeof EConfigType]

export const ENodeTechnologyType = {
	globalEnbId: 'globalEnbId',
	globalGnbId: 'globalGnbId',
} as const;

export type TNodeTechnologyType = typeof ENodeTechnologyType[keyof typeof ENodeTechnologyType]

export const gNode: Record<string, TNodeCardTypeValue<IGlobalGnbId>> = {
	plmn: {
		name: 'plmn',
		title: 'PLMN',
	},
	name: {
		name: 'gnbName',
		title: 'Gnb Name',
	},
	id: {
		name: 'gnbId',
		title: 'Gnb ID',
	},
	idBits: {
		name: 'gnbIdBits',
		title: 'Gnb ID Bits',
	},
};

export const eNode: Record<string, TNodeCardTypeValue<IGlobalEnbId>> = {
	plmn: {
		name: 'plmn',
		title: 'PLMN',
	},
	name: {
		name: 'enbName',
		title: 'Enb Name',
	},
	id: {
		name: 'enbId',
		title: 'Enb ID',
	},
	idBits: {
		name: 'enbIdType',
		title: 'Enb ID Type',
	},
};

export const nodeType = {
	gNode,
	eNode,
};

export const ETechnologyTableTitles = {
	cellId: 'cell Id',
	name: 'cell name',
	zone: 'zone',
	antennaModel: 'antenna Model',
	height: 'height',
	mechanicalTilt: 'mechanical Tilt',
	mechanicalTiltBracket: 'mechanical Tilt\nBracket',
	mechanicalTiltBracketMount: 'mechanical Tilt\nBracket Mount',
	electricalTilt: 'electrical lTilt',
	spinningRange: 'spinning Range',
	azimuth: 'azimuth',
	nrarfcn: 'nrarfcn',
	band5g: 'band5g',
	band4g: 'band4g',
	title: 'title',
	totalTilt: 'total Tilt',
	earfcn: 'earfcn',
	tac: 'tac',
	pci: 'pci',
} as const;

export type TTechnologyTableTitles = typeof ETechnologyTableTitles[keyof typeof ETechnologyTableTitles]

export const ETechnologyTableFields = {
	cellId: 'cellId',
	name: 'name',
	zone: 'zone',
	antennaModel: 'antennaModel',
	height: 'height',
	mechanicalTilt: 'mechanicalTilt',
	mechanicalTiltBracket: 'mechanicalTiltBracket',
	mechanicalTiltBracketMount: 'mechanicalTiltBracketMount',
	electricalTilt: 'electricalTilt',
	spinningRange: 'spinningRange',
	azimuth: 'azimuth',
	nrarfcn: 'nrarfcn',
	band5g: 'band5g',
	band4g: 'band4g',
	title: 'title',
	totalTilt: 'totalTilt',
	earfcn: 'earfcn',
	tac: 'tac',
	pci: 'pci',
} as const;

export type TTechnologyTableFields = TValueOfStringRecord<typeof ETechnologyTableFields>
